import Vue from 'vue'
import PrismicVue from 'prismic-vue'
import linkResolver from './prismic/link-resolver'
import htmlSerializer from './prismic/html-serializer'
import App from './App.vue'
import router from './router'
import VueScrollTo from 'vue-scrollto';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faAngleUp, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueMeta from 'vue-meta'

Vue.config.productionTip = false

library.add(faAngleUp)
library.add(faTimes)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(PrismicVue, {
  endpoint: window.prismic.endpoint,
  linkResolver,
  htmlSerializer
})

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})

Vue.use(VueScrollTo)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
